<template>
  <div class="telegram-button-wrapper">
    <button class="telegram-button social-button">
      <img src="@/assets/images/SignIn/telegram.svg" alt="Telegram" />
    </button>
    <div id="telegram-widget-container" ref="telegramWidget" class="telegram-widget-overlay"></div>
  </div>
</template>

<script>
import './styles.scss'

export default {
  name: 'TelegramButton',

  data() {
    return {
      URL: 'https://telegram.org/js/telegram-widget.js?22'
    }
  },

  mounted() {
    this.setupTelegramAuth()
    this.fixIframeOpacity()
  },

  beforeDestroy() {
    // Очистка при размонтировании
    if (this.$refs.telegramWidget) {
      this.$refs.telegramWidget.innerHTML = ''
    }
    delete window.onTelegramAuth
  },

  methods: {
    fixIframeOpacity() {
      // Исправление проблемы с кликами на iframe с opacity: 0
      // Устанавливаем opacity: 1 на короткое время, затем возвращаем обратно к 0
      const checkIframe = () => {
        const iframe = this.$refs.telegramWidget?.querySelector('iframe')
        if (iframe) {
          // Временно устанавливаем opacity: 1
          iframe.style.opacity = '1'

          // Через небольшую задержку возвращаем opacity: 0
          // Это заставляет браузер корректно зарегистрировать интерактивную область
          setTimeout(() => {
            iframe.style.opacity = '0.001'
          }, 50)
        } else {
          // Если iframe еще не создан, проверяем снова через 100ms
          setTimeout(checkIframe, 100)
        }
      }

      // Начинаем проверку после небольшой задержки
      setTimeout(checkIframe, 100)
    },

    setupTelegramAuth() {
      const self = this

      // ВАЖНО: устанавливаем callback ПЕРЕД добавлением скрипта
      window.onTelegramAuth = async (user) => {
        try {
          const userData = {
            id: user.id,
            first_name: user.first_name,
            last_name: user.last_name,
            username: user.username,
            photo_url: user.photo_url,
            auth_date: user.auth_date.toString(),
            hash: user.hash
          }

          const response = await fetch('https://users.backend-pier.com/api/v1/user/login-tg', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(userData)
          })

          const data = await response.json()

          if (data.auth_token && data.data) {
            self.$store.dispatch('signIn', data)

            // Устанавливаем валюту и язык из ответа бэкенда
            if (data.data.currency) {
              self.$store.commit('setCurrency', data.data.currency.toLowerCase())
            }
            if (data.data.language) {
              self.$store.commit('setLanguage', data.data.language.toLowerCase())
            }

            if (self.$analytics) {
              self.$analytics.send('login', {
                type: 'login',
                method: 'telegram',
                user_id: data.data?.user_id
              })
              self.$analytics.setUser(data.data?.user_id)
            }

            // Эмитим событие успешной авторизации родительскому компоненту
            self.$emit('auth-success', data)
          }
        } catch (error) {
          console.error('Error during Telegram authentication:', error)
        }
      }

      // Проверяем, не добавлен ли уже iframe ГЛОБАЛЬНО в DOM
      const existingIframe = document.querySelector('iframe#telegram-login-robuxpier_auth_bot')

      if (!existingIframe) {
        // Если iframe нет, проверяем наличие скрипта в контейнере
        const existingScript = this.$refs.telegramWidget?.querySelector('script[src*="telegram-widget.js"]')

        if (!existingScript && this.$refs.telegramWidget) {
          // Очищаем контейнер перед добавлением скрипта
          this.$refs.telegramWidget.innerHTML = ''

          const script = document.createElement('script')
          script.async = true
          script.src = this.URL
          script.setAttribute('data-telegram-login', 'robuxpier_auth_bot')
          script.setAttribute('data-size', 'large')
          script.setAttribute('data-radius', '7')
          script.setAttribute('data-onauth', 'onTelegramAuth(user)')
          script.setAttribute('data-request-access', 'write')
          script.setAttribute('data-userpic', 'false')

          this.$refs.telegramWidget.appendChild(script)
        }
      } else {
        // Перемещаем существующий iframe в текущий контейнер
        this.$refs.telegramWidget.innerHTML = ''
        this.$refs.telegramWidget.appendChild(existingIframe)
      }
    }
  }
}
</script>
